import { useNavigate, useLocation } from 'react-router';

export default function ErrorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { heading, description } = location.state || {};
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-red-600">{heading || ''}</h1>
        <p className="mt-4 text-lg text-gray-700">{description || 'An unexpected error has occurred.'}</p>
        <button
          onClick={() => navigate('/')}
          className="mt-6 px-4 py-1 border border-primary bg-secondary text-primary rounded-md hover:bg-primary hover:text-secondary cursor-pointer disabled:hover:bg-secondary disabled:hover:text-gray-200 disabled:text-gray-200 disabled:border-gray-200 disabled:cursor-not-allowed"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
}